export const skillGroups = [
  {
    title: "Frontend",
    skills: ["React", "Angular", "HTML5", "CSS3", "JavaScript", "Tailwind/CSS"],
  },
  {
    title: "Backend",
    skills: ["Node.js (Express)", "Java", "Spring Boot", "REST API"],
  },
  {
    title: "Database",
    skills: ["PostgreSQL", "MongoDB", "SQLite", "Gestione banche dati"],
  },
  {
    title: "IoT / Data",
    skills: ["ESP32", "MQTT", "ThingsBoard", "Grafana", "C/C++"],
  },
  {
    title: "AI / Automazione",
    skills: ["Integrazione IA", "Automazione processi", "Proof of Concept"],
  },
  {
    title: "Architettura software",
    skills: ["Web app su misura", "Sistemi scalabili", "Deploy", "Monitoraggio"],
  },
];
